export default __webpack_public_path__ + "static/media/toneel-1080.c7c0d393.jpg";